import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { BbitWebsiteMetaDataService, I18nPipe } from '@bbitgmbh/website.sdk';
import { AccessComponent } from '../../access/access.component';
import { PlaceBookingService } from '../booking.service';

@Component({
  selector: 'app-booking-selection',
  templateUrl: './booking-selection.component.html',
  styleUrl: './booking-selection.component.scss',
  imports: [RouterLink, FormsModule, I18nPipe, AccessComponent],
})
export class BookingSelectionComponent implements OnInit {
  constructor(
    public booking: PlaceBookingService,
    private _meta: BbitWebsiteMetaDataService,
  ) {}

  async ngOnInit(): Promise<void> {
    this._meta.update({
      title: 'Trainingsflächen buchen',
      description: '',
    });
  }
}
